import { render, staticRenderFns } from "./AddToSalesForce.vue?vue&type=template&id=2aa27850"
import script from "./AddToSalesForce.vue?vue&type=script&lang=js"
export * from "./AddToSalesForce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports